export const SyncStatus = {
  PENDING: 'pending',
  IMPORTING: 'importing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const

export type SyncStatusType = (typeof SyncStatus)[keyof typeof SyncStatus]

export const syncStatusMap: Record<SyncStatusType, string> = {
  [SyncStatus.PENDING]: '未匯入',
  [SyncStatus.IMPORTING]: '匯入中',
  [SyncStatus.COMPLETED]: '已匯入',
  [SyncStatus.FAILED]: '匯入失敗',
}
